export default __webpack_public_path__ + "static/media/calendar.3e5d0cdb.svg";